"use client";
import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import redirectURL from "../redirectURL";
import Select from "react-select";
import * as XLSX from "xlsx";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const NewFinishedGoodsInventory = () => {
  // const today = new Date().toISOString().split("T")[0];

  const today = new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });
  // const today = "2025-11-22";



  const [loadshow, setLoadshow] = useState("show-n");
  const [currentDate, setCurrentDate] = useState(today);
  const [overlayBlock, setOverlayBlock] = useState("show-n");
  const [show, setShow] = useState(false);
  const [basicTitle, setBasicTitle] = useState("");
  const [basicType, setBasicType] = useState("default");
  const [rowData, setRowData] = useState([]);
  const [columnWithDefs, setColumnWithDefs] = useState([]);
  const [currentinvoiceDate, setCurrentInvoiceDate] = useState(new Date())
  const [storeId, setStoreId] = useState({
    label: "FG STOCK",
    value: "fg_stock",
  });
  const [isSliderOpen, setSliderOpen] = useState(false);
  const [sliderTitle, setSliderTitle] = useState("Trigger Action");
  const [triggerDate, setTriggerDate] = useState(today);
  const [triggerDateOption, setTriggerDateOption] = useState([{ label: today, value: today }]);
  const [dateStatus, setDateStatus] = useState("");
  const [triggerEmail, setTriggerEmail] = useState("");
  const [allowedTriggerDates, setAllowedTriggerDates] = useState([]);
  const [triggerNote, setTriggerNote] = useState(null);
  const [triggerStatus, setTriggerStatus] = useState("warning");
  const [primaryTriggerStatus, setPrimaryTriggerStatus] = useState(null);
  const [showDownloadMessage, setShowDownloadMessage] = useState(false);
  const [errorMessage, seterrorMessage] = useState("");
  const [errorData, seterrorData] = useState("");
  const [prevDate, setPrevDate] = useState([])
  const [highlightedDates, setHighlightedDates] = useState([]);
  const [storeOptions, setStoreOptions] = useState([]);


  const handleDownload = () => {
    // Example: Download a text file with the message
    const element = document.createElement("a");
    const file = new Blob([errorMessage || "Your download message goes here"], {
      type: "text/plain",
    });
    element.href = URL.createObjectURL(file);
    element.download = "message.txt";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };
  // console.log({primaryTriggerStatus})


  const [dateError, setDateError] = useState("");
  // console.log("DateStatus", DateStatus);

  // const storeOptions = useMemo(
  //   () => [
  //     { label: "FG STOCK", value: "fg_stock" },
  //     { label: "OOS", value: "oos" },
  //     { label: "DOH_WH", value: "doh_wh" },
  //     { label: "DOH_ALL", value: "doh_all" },
  //     { label: "Overall Inventory", value: "overall_inventory" },
  //   ],
  //   []
  // );


  const [isTriggered, setIsTriggered] = useState(false);
  const gridApi = useRef(null);
  const gridColumnApi = useRef(null);

  const autoSizeAllColumns = () => {
    if (gridColumnApi.current) {
      const allColumns = gridColumnApi.current.getAllColumns();
      if (allColumns?.length) {
        const allColumnIds = allColumns.map((col) => col.getColId());
        gridColumnApi.current.autoSizeColumns(allColumnIds, false);
      }
    }
  };

  const onGridReady = (params) => {
    gridApi.current = params.api;
    gridColumnApi.current = params.columnApi;
    setTimeout(() => autoSizeAllColumns(), 100);
  };

  const defaultColDef = useMemo(
    () => ({
      sortable: true,
      filter: true,
      pivot: true,
      enableValue: true,
      enableRowGroup: true,
      resizable: true,
    }),
    []
  );

  // Removed Excel export configuration to keep only CSV export

  // CSV export: format dates as dd-mm-yy text (CSV has no cell types/styles)
  const csvExportParams = useMemo(
    () => ({
      processCellCallback: (params) => {
        const colDef = params?.column?.getColDef?.() || {};
        if (colDef.type === "dateColumn") {
          const raw = params?.node?.data?.[colDef.field];
          if (!raw) return "";
          const d = new Date(raw);
          if (isNaN(d.getTime())) return raw;
          // Use ISO format (YYYY-MM-DD) to avoid locale-dependent parsing in Excel
          const yyyy = String(d.getUTCFullYear());
          const mm = String(d.getUTCMonth() + 1).padStart(2, "0");
          const dd = String(d.getUTCDate()).padStart(2, "0");
          return `${yyyy}-${mm}-${dd}`;
        }
        return params.value;
      },
    }),
    []
  );

  // Keep only CSV export in menus: replace default 'export' submenu with CSV-only
  const getContextMenuItems = React.useCallback((params) => {
    const defaults = params.defaultItems ? [...params.defaultItems] : [];
    const items = defaults.filter((item) => item !== "export");
    items.push({
      name: "Export",
      subMenu: [
        {
          name: "CSV Export",
          action: () => params.api.exportDataAsCsv(csvExportParams),
        },
      ],
    });
    return items;
  }, [csvExportParams]);

  const getMainMenuItems = React.useCallback((params) => {
    const defaults = params.defaultItems ? [...params.defaultItems] : [];
    const items = defaults.filter((item) => item !== "export");
    items.push({
      name: "Export",
      subMenu: [
        {
          name: "CSV Export",
          action: () => params.api.exportDataAsCsv(csvExportParams),
        },
      ],
    });
    return items;
  }, [csvExportParams]);

  const sideBar = useMemo(
    () => ({
      toolPanels: [
        {
          id: "columns",
          labelDefault: "Columns",
          iconKey: "columns",
          toolPanel: "agColumnsToolPanel",
        },
        {
          id: "filters",
          labelDefault: "Filters",
          iconKey: "filter",
          toolPanel: "agFiltersToolPanel",
        },
      ],
    }),
    []
  );

  const statusPanel = {
    statusPanels: [
      { statusPanel: "agTotalAndFilteredRowCountComponent", align: "left" },
      { statusPanel: "agTotalRowCountComponent", align: "center" },
      { statusPanel: "agFilteredRowCountComponent" },
      { statusPanel: "agSelectedRowCountComponent" },
      { statusPanel: "agAggregationComponent" },
    ],
  };

  const generateColumnDefs = (data) => {
    if (!Array.isArray(data) || !data.length) return [];

    const samples = data.slice(0, Math.min(data.length, 5));
    const columnMap = {};

    samples.forEach((record) => {
      Object.entries(record).forEach(([key, value]) => {
        if (
          key === "_id" ||
          key === "sheet_id" ||
          key === "sr" ||
          key === "created_date" ||
          key === "sheet_name" ||
          key === "category_x"
        )
          return;

        if (!columnMap[key]) {
          let type = typeof value;
          const lowerKey = key.toLowerCase();
          if (lowerKey === "b2c_oos") {
            type = "date";
          }
          if (
            (type === "string" &&
              !isNaN(Date.parse(value)) &&
              (lowerKey.includes("date") ||
                lowerKey === "b2b_oos" ||
                lowerKey === "b2c_oos")) ||
            lowerKey.includes("date")
          ) {
            type = "date";
          }

          if (value === null) type = "string";

          var headerName = key
            .replace(/_/g, " ")
            .replace(/\b\w/g, (l) => l.toUpperCase());
          // Ensure B2B, B2C, and DOH are in uppercase
          headerName = headerName
            .replace(/\bB2b\b/gi, "B2B")
            .replace(/\bB2c\b/gi, "B2C")
            .replace(/\bOos\b/gi, "OOS")
            .replace(/\bDs\b/gi, "DS")
            .replace(/\bDoh\b/gi, "DOH");

          headerName = headerName
            .replace(/\bB2b\b/g, "B2B")
            .replace(/\bB2c\b/g, "B2C");

          headerName = headerName
          .replace(/\bRr\b/g, "RR")
          .replace(/\bDp\b/g, "DP");

          columnMap[key] = {
            headerName,
            field: key,
            type,
          };
        }

      });
    });

    return Object.values(columnMap).map((col) => {
      const baseWidth = col.headerName.length * 8 + 40;
      const def = {
        headerName: col.headerName,
        field: col.field,
        sortable: true,
        filter: true,
        width: baseWidth,
        headerClass: "ag-header-wrap-text",
        autoHeaderHeight: true,
      };
      if (col.type === "number") {
        // def.type = "numericColumn";
        // def.cellStyle = { textAlign: "right" };
      } else if (col.type === "date") {
        def.type = "dateColumn";
        // previous code for date formatter

        // def.valueFormatter = ({ value }) => {
        //   if (!value) return '';
        //   const date = new Date(value);
        //   return isNaN(date.getTime()) ? value : date.toISOString().split('T')[0];
        // };

        // New code for date formatter

        def.valueFormatter = ({ value }) => {
          if (!value) return "";
          const date = new Date(value);
          return isNaN(date.getTime())
            ? value
            : `${String(date.getDate()).padStart(2, "0")}/${String(
              date.getMonth() + 1
            ).padStart(2, "0")}/${date.getFullYear()}`;
        };
        // Tag cells for Excel export styling (date data type)
        def.cellClass = "dateType";
        // Ensure date filter is used and operates on true Date values
        // def.filter = "agDateColumnFilter";
        // def.filterParams = {
        //   buttons: ["reset", "apply"],
        //   closeOnApply: true,
        // };
        def.filterValueGetter = (params) => {
          const raw = params.data ? params.data[col.field] : params.value;
          if (!raw) return null;
          const parsed = new Date(raw);
          return isNaN(parsed.getTime()) ? null : parsed;
        };
      }
      return def;
    });
  };

  const getMainData = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    try {
      const response = await redirectURL.post(
        "inventory/getNewFGInventoryData",
        {}
      );
      if (response.status === 200) {
        const data = response.data.data || [];
        setHighlightedDates((response.data.dates || []).map((d) => new Date(d)));
        const colDefs = generateColumnDefs(data);
        setRowData(data);
        setColumnWithDefs(colDefs);
        setCurrentInvoiceDate(new Date(response.data.created_date?.split("T")[0] || ""));

        const options = (response.data.options || []).map(e => ({
          label: String(e.label),
          value: String(e.value),
        }));

        setStoreOptions(options);
        setStoreId({
          label: response.data.sheet_name,
          value: response.data.sheet_id,
        });
        setTimeout(() => autoSizeAllColumns(), 100);
      }
    } catch (error) {
      setShow(true);
      setBasicTitle("Failed to fetch Finished Goods Inventory data");
      setBasicType("error");
    }
    setLoadshow("show-n");
    setOverlayBlock("show-n");
  };

  const getDynamicSheetNames = async (date) => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    const sheets = await redirectURL.post('/inventory/getDynamicSheetNames', { date: date.toISOString().split("T")[0] });
    if (sheets.data.status === "success"){
      const sheetNames = sheets.data.sheets
      const options = (sheetNames || []).map(e => ({
          label: String(e.label),
          value: String(e.value),
        }));
      setStoreOptions(options)
      setLoadshow("show-n");
    setOverlayBlock("show-n");
    }
  }

  const getFilteredData = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    try {
      var params = {};
      params.created_date = currentinvoiceDate || "";
      params.sheet_id = storeId?.value || "";
      const response = await redirectURL.post(
        "inventory/getNewFGInventoryByFilters",
        params
      );
      if (response.status === 200) {
        const data = response.data.data || [];
        const colDefs = generateColumnDefs(data);
        setRowData(data);
        setColumnWithDefs(colDefs);
        setTimeout(() => autoSizeAllColumns(), 100);
      }
    } catch (error) {
      setShow(true);
      setBasicTitle("Failed to fetch Finished Goods Inventory data");
      setBasicType("error");
    }
    setLoadshow("show-n");
    setOverlayBlock("show-n");
  };
  const resetFilters = async () => {
    setLoadshow("show-m")
    setOverlayBlock("show-m")
    await getMainData()
    // setCurrentInvoiceDate("")
    // setStoreId(storeOptions[0]);
    // setTimeout(() => getMainData(), 100);
  };

  const onClickGetMailData = async () => {
    try {
      setLoadshow("show-m");
      setOverlayBlock("show-m");

      const payload = {
        created_date: currentinvoiceDate || today,
        sheet_id: storeId?.value || "",
        email: localStorage.getItem("email")
      };

      const response = await redirectURL.post(
        "inventory/getMailData",
        payload
      );

      setLoadshow("show-n");
      setOverlayBlock("show-n");

      const status = response?.data?.status || "success";
      const message =
        response?.data?.message || "Mail Sent Successfully";

      setShow(true);
      setBasicTitle(message);
      setBasicType(status === "success" ? "success" : status === "info" ? "info" : "error");
    } catch (error) {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setShow(true);
      setBasicTitle(
        error?.response?.data?.message || "Failed to get mail data."
      );
      setBasicType("error");
    }
  }

  const onClickTriggerBtn = async () => {

    setLoadshow("show-m");
    setOverlayBlock("show-m");
    try {
      const response = await redirectURL.post("inventory/checkTriggerStatus", { currentDate });

      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setSliderOpen(true);
      setSliderTitle("Trigger Inventory Process");

      if (response?.data) {
        const { status, message, missed_warehouses, missed_darkstores, stn_status, trigger_status } = response.data;
        setTriggerStatus(status);
        setPrimaryTriggerStatus(trigger_status);
        setTriggerNote({
          status,
          message,
          missedWarehouses: missed_warehouses || [],
          missedDarkstores: missed_darkstores || [],
          stnStatus: stn_status || null,
        });
      }

    } catch (err) {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setTriggerNote({
        status: "fail",
        message: "Something went wrong while checking trigger status.",
        missedWarehouses: [],
        missedDarkstores: [],
        stnStatus: null,
      });
    }
  };


  // const onClickTriggerBtn = async () => {
  //   setSliderOpen(true);
  //   setSliderTitle("Trigger Inventory Process");

  //   setLoadshow("show-m");
  //   setOverlayBlock("show-m");

  //   try{
  //     const response = await redirectURL.post("inventory/checkTriggerStatus", {currentDate});

  //    setLoadshow("show-n");
  //   setOverlayBlock("show-n");
  //     console.log(response, "response")

  //   }catch(err) {

  //   }

  //   // setLoadshow("show-m");
  //   // setOverlayBlock("show-m");
  //   // const fetchReqDates = await redirectURL.post("/inventory/fetchReqDates");
  //   // if (fetchReqDates.data.status === "success") {
  //   //   const dates = fetchReqDates.data.data || [];
  //   //   dates.unshift({ label: "Select Date :", value: "" });
  //   //   setAllowedTriggerDates(dates);
  //   //   setSliderOpen(true);
  //   //   setSliderTitle("Trigger Inventory Process");
  //   //   setLoadshow("show-n");
  //   //   setOverlayBlock("show-n");
  //   // } else {
  //   //   // setAllowedTriggerDates()
  //   //   setLoadshow("show-n");
  //   //   setOverlayBlock("show-n");
  //   //   setBasicTitle("No Dates Found");
  //   //   setBasicType("warning");
  //   //   setShow(true);
  //   // }
  // };
  
  const setTriggerStatusTo500 = async (date) => {
    try {
      await redirectURL.post("inventory/setTriggerTo500", { date });
    } catch (err) {
    }
  };

  const onClickingSliderCloseIcon = () => {
    setSliderOpen(false);
    setTriggerDate("");
    setTriggerEmail("");
    setDateError("");
    setDateStatus("");
  };

  // Function To Trigger User Action
  const triggerUserAction = (trigerdata) => {
    redirectURL.post('inventory/triggerUserAction', trigerdata)
  }

  const onTriggerSubmit = async (e) => {
    // e.preventDefault();
    if (!currentDate) {
      setDateError("Date selection is mandatory.");
      return;
    }
    setDateError("");
    setLoadshow("show-m");
    setOverlayBlock("show-m");

    try {
      const triggerResponse = await redirectURL.post(
        "inventory/onTriggerInventory",
        {
          trigger_date: currentDate,
          email: localStorage.getItem("email"),
          created_date: new Date().toISOString().split("T")[0],
          process: 0,
        }
      );

      if (triggerResponse.data.status === "success") {
        await getMainData();
        const backendStatus = triggerResponse.data.response.status !== "Success";
        const errorType = triggerResponse.data.response.response_type
        const isSkuCodeNotFoundRError = errorType === "SKU Code Not Found Error" || errorType === "M_date Exceed Error" || errorType === "Shelf Life Empty Error" || errorType  === "Provided Empty Closing Balance";
        
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setSliderOpen(false);
        setTriggerDate("");
        setTriggerEmail("");
        setDateError("");
        setShow(true);
        setBasicTitle(
          backendStatus
            ? triggerResponse?.data?.response?.message
            : "Inventory Triggered Successfully"
        );
        setBasicType(backendStatus ? "info" : "success");
        setShowDownloadMessage(isSkuCodeNotFoundRError);
        seterrorMessage(isSkuCodeNotFoundRError ? triggerResponse?.data?.response?.message : "");
        seterrorData(isSkuCodeNotFoundRError ? triggerResponse?.data?.response?.response_data : []);

        // User Action Triggering Starts Here
        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Inventory Triggered",
          status: "Success",
          path: window.location.pathname
        }
        triggerUserAction(userData)
        // User Action Triggering Ends Here

      } else {
        setShow(true);
        setBasicTitle("Failed to Trigger Inventory");
        setBasicType("error");

        // User Action Triggering Starts Here
        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          aaction: "Inventory Triggered",
          status: "Failure",
          path: window.location.pathname
        }
        triggerUserAction(userData)
        // User Action Triggering Ends Here
      }
    } catch (error) {
      console.error("Error triggering inventory:", error);
      await setTriggerStatusTo500(currentDate)
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setShow(true);
      setBasicTitle("Something went wrong. Please try again later.");
      setBasicType("error");
      // User Action Triggering Starts Here
      var userData = {
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "Inventory Triggered",
        status: "Failure",
        path: window.location.pathname
      }
      triggerUserAction(userData)
      // User Action Triggering Ends Here
    }
  };

  const onReTriggerSubmit = async () => {
    if (!triggerDate) {
      setDateError("Date selection is mandatory.");
      return;
    }

    setDateError("");
    setLoadshow("show-m");
    setOverlayBlock("show-m");

    try {
      const payload = {
        trigger_date: new Date(triggerDate + "T00:00:00.000Z"), // Normalize to start of day UTC
        email: localStorage.getItem("email"),
        updated_date: new Date().toISOString().split("T")[0], // yyyy-mm-dd
      };

      const triggerResponse = await redirectURL.post(
        "inventory/onReTriggerInventory",
        payload
      );

      const { status, message } = triggerResponse.data;

      setLoadshow("show-n");
      setOverlayBlock("show-n");

      if (status === "success") {
        await getMainData();
        setSliderOpen(false);
        setDateStatus(null);
        setTriggerDate("");
        setTriggerEmail("");
        setDateError("");
        setShow(true);
        setBasicTitle("Inventory Re-Triggered Successfully");
        setBasicType("success");
      } else {
        setDateStatus(null);
        setShow(true);
        setBasicTitle(message || "Failed to Re-Trigger Inventory");
        setBasicType("error");
      }
    } catch (error) {
      console.error(
        "Re-trigger error:",
        error.response.data.message || error.message
      );
      setDateStatus(null);
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setShow(true);
      setBasicTitle(error.response.data.message || error.message);
      setBasicType("error");
    }
  };

  useEffect(() => {
    if (!rowData.length) getMainData();
  }, []);

  const closeAlert = () => {
    setShow(false);
    setLoadshow("show-n");
    setOverlayBlock("show-n");
    setDateStatus(null);
    seterrorMessage("");
  };

  // const downloadError = () => {
  //   // Map your errorData to have both columns
  //   const data = errorData.map(item => ({
  //     "Sku Code": item["Sku Code"],
  //     "Warehouse / Darkstore": item["Warehouse / Darkstore"]
  //   }));

  //   // Create worksheet
  //   const worksheet = XLSX.utils.json_to_sheet(data);

  //   // Create workbook
  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Error_SKUs");

  //   // Trigger download
  //   XLSX.writeFile(workbook, "error_sku_codes.xlsx");
  // };

  const downloadError = () => {
    if (!errorData || errorData.length === 0) {
      alert("No error data available");
      return;
    }

    // Collect all unique keys across rows
    const allKeys = [...new Set(errorData.flatMap(item => Object.keys(item)))];

    // Map rows ensuring all columns are present
    const data = errorData.map(item => {
      const row = {};
      allKeys.forEach(key => {
        row[key] = item[key] || ""; // empty if missing
      });
      return row;
    });

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Error_SKUs");
    XLSX.writeFile(workbook, "error_skus.xlsx");
  };

  const handleRevokeTrigger = async () => {
    if (!currentDate) {
      setDateError("Date Selection is Mandatory.");
      return;
    }

    setDateError("");
    setLoadshow("show-m");
    setOverlayBlock("show-m");

    try {
      const payload = { trigger_date: currentDate };
      const response = await redirectURL.post(
        "inventory/revokeTriggerInventory",
        payload
      );

      const { status, message } = response.data;
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      if (status === "success") {
        await getMainData();
        setSliderOpen(false);
        setDateStatus(null);
        setTriggerDate("");
        setTriggerEmail("");
        setShow(true);
        setBasicTitle("Inventory Revoked Successfully");
        setBasicType("success");
        // User Action Triggering Starts Here
        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Inventory Revoked",
          status: "Success",
          path: window.location.pathname
        }
        triggerUserAction(userData)
        // User Action Triggering Ends Here
      } else {
        setDateStatus(null);
        setShow(true);
        setBasicTitle(message || "Failed to Revoke Inventory");
        setBasicType("error");
        // User Action Triggering Starts Here
        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Inventory Revoked",
          status: "Failure",
          path: window.location.pathname
        }
        triggerUserAction(userData)
        // User Action Triggering Ends Here
      }
    } catch (error) {
      console.error("Revoke error:", error.response.data.message || error.message);
      setDateStatus(null);
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setShow(true);
      setBasicTitle(error.response.data.message || error.message);
      setBasicType("error");
      // User Action Triggering Starts Here
      var userData = {
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "Inventory Revoked",
        status: "Failure",
        path: window.location.pathname
      }
      triggerUserAction(userData)
      // User Action Triggering Ends Here
    }
  }

  const onClickDownloadFilData = async () => {
    if (!currentDate) {
      setDateError("Date selection is mandatory.");
      return;
    }

    setDateError("");
    setLoadshow("show-m");
    setOverlayBlock("show-m");

    try {
      const payload = { created_date: currentinvoiceDate.toISOString().split("T")[0] };
      const response = await redirectURL.post(
        "inventory/downloadCurrentFgOutputDataByDate",
        payload,
        { responseType: "blob" }
      );

      // Hide loader
      setLoadshow("show-n");
      setOverlayBlock("show-n");

      // Create Blob and trigger download
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `finished_goods_inventory_${currentinvoiceDate.toISOString().split("T")[0]}.xlsx`;
      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.remove();
      window.URL.revokeObjectURL(url);

    } catch (error) {
      console.error("Download error:", error?.response?.data?.message || error.message);

      setDateStatus(null);
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setShow(true);
      setBasicTitle(error?.response?.data?.message || error.message);
      setBasicType("error");

      // User Action Logging
      triggerUserAction({
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "Inventory Download",
        status: "Failure",
        path: window.location.pathname,
      });
    }
  };

  return (
    <div className="container-fluid mt-3">
      <SweetAlert
        show={show}
        type={basicType}
        title={basicTitle}
        onConfirm={closeAlert}
        style={{ fontSize: "9px" }}
        confirmBtnText="OK"
        customButtons={
          <>
            {basicTitle && showDownloadMessage && (
              <button className="btn btn-success" onClick={downloadError}>
                Download Missing Sku's
              </button>
            )}

            <button className="btn btn-primary" onClick={closeAlert}>
              Close
            </button>
          </>
        }
      >
        {/* {errorMessage} */}
      </SweetAlert>

      <div
        className="row"
        style={{ fontSize: "0.9rem", fontFamily: "Arial, sans-serif" }}
      >
        <div className="col-sm-12 p-0">
          <h1
            className="col-sm-12"
            style={{
              color: "#B9366D",
              fontSize: "18px",
              fontWeight: "bold",
              fontFamily: "sans-serif",
            }}
          >
            Finished Goods Inventory
          </h1>
        </div>
        <form
          className="col-sm-12 p-0 mt-4 mb-4"
          style={{ display: "flex", alignItems: "center" }}
        >
          <div className="col-sm-8 row ">
            {/* <div
              className="col-sm-3 mb-1"
              style={{ display: "flex", flexDirection: "column" }}
            >
              <label style={{ fontSize: "13px", fontWeight: "400" }}>
                Created Date:
              </label>
              <input
                type="date"
                value={currentinvoiceDate}
                onChange={(e) => {
                  setCurrentInvoiceDate(e.target.value);
                }}
                style={{
                  padding: "7px",
                  borderRadius: "5px",
                  border: "1px solid #d9d9d9",
                  width: "100%",
                  marginBottom: "15px",
                  cursor: "pointer",
                }}
                onClick={() =>
                  document.getElementById("invoiceDate")?.showPicker?.()
                }
                id="invoiceDate"
              />
            </div> */}
            <div
              className="col-sm-3 mb-1"
              style={{ display: "flex", flexDirection: "column" }}
            >
              <label style={{ fontSize: "13px", fontWeight: "400" }}>Created Date:</label>

              <DatePicker
                selected={new Date(currentinvoiceDate)}
                onChange={(date) => {
                  setPrevDate(new Date(currentinvoiceDate));
                  setCurrentInvoiceDate(date);
                  getDynamicSheetNames(date)
                }}
                dateFormat="yyyy-MM-dd"
                className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                wrapperClassName="w-full"
                highlightDates={[
                  {
                    "react-datepicker__day--highlighted-custom": highlightedDates,
                  },
                ]}
              />
            </div>
            <div
              className="col-sm-3 mb-1"
              style={{ display: "flex", flexDirection: "column" }}
            >
              <label
                htmlFor="storeId"
                style={{ fontSize: "13px", fontWeight: "400" }}
              >
                Sheet Name :
              </label>
              <Select
                id="storeId"
                value={storeId}
                onChange={(selectedOption) => setStoreId(selectedOption)}
                options={storeOptions}
                styles={selectStyles}
              />
            </div>
            <div
              className="ml-4 mt-4"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                gap: "0px 10px",
              }}
            >
              <button
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  getFilteredData();
                }}
                style={{
                  backgroundColor: "#93385D",
                  color: "#fff",
                  borderRadius: "5px",
                  padding: "8px 20px",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                Apply
              </button>
              <button
                onClick={(e) => {
                  e.preventDefault();
                  resetFilters();
                }}
                type="button"
                style={{
                  backgroundColor: "#fff",
                  color: "#000",
                  borderRadius: "5px",
                  padding: "8px 20px",
                  border: "1px solid #d9d9d9",
                  cursor: "pointer",
                }}
              >
                Reset
              </button>
            </div>
          </div>
          <div className="mt-4" style={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>
            {/* <button
              onClick={(e) => {
                e.preventDefault();
                onClickGetMailData();
              }}
              type="button"
              style={{
                backgroundColor: "#93385D",
                color: "#fff",
                borderRadius: "5px",
                padding: "8px 20px",
                border: "1px solid #d9d9d9",
                cursor: "pointer",
              }}
            >
              <i className="fa fa-envelope" style={{ marginRight: "8px" }} />
              Mail FG Data
            </button> */}
            <button
              onClick={(e) => {
                e.preventDefault();
                onClickDownloadFilData();
              }}
              type="button"
              style={{
                backgroundColor: "#fff",
                color: "#333",
                border: "1px solid #ccc",
                borderRadius: "6px",
                padding: "8px 20px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                // fontSize: "14px",
                transition: "all 0.2s ease-in-out",
                marginRight: "10px",
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = "scale(1.05)";
                e.currentTarget.style.boxShadow = "0 4px 8px rgba(0,0,0,0.1)";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = "scale(1)";
                e.currentTarget.style.boxShadow = "none";
              }}
            >
              <i className="fa fa-download " style={{ marginRight: "8px", color: "#555" }} />
              Finished Goods Inventory
            </button>

            <button
              onClick={(e) => {
                e.preventDefault();
                onClickTriggerBtn();
              }}
              type="button"
              style={{
                backgroundColor: "#93385D",
                color: "#fff",
                borderRadius: "5px",
                padding: "8px 20px",
                border: "1px solid #d9d9d9",
                cursor: "pointer",
                transition: "all 0.2s ease-in-out",
                marginRight: "10px",

              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = "scale(1.05)";
                e.currentTarget.style.boxShadow = "0 4px 8px rgba(0,0,0,0.2)";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = "scale(1)";
                e.currentTarget.style.boxShadow = "none";
              }}
            >
              Trigger Inventory
            </button>

          </div>
        </form>

        <div className="col-sm-12 mt-3">
          <div className="ag-theme-alpine" style={{ height: 500 }}>
            <AgGridReact
              rowData={rowData}
              columnDefs={columnWithDefs}
              defaultColDef={defaultColDef}
              defaultCsvExportParams={csvExportParams}
              onGridReady={onGridReady}
              sideBar={sideBar}
              statusBar={statusPanel}
              pagination={true}
              paginationPageSize={10000}
              enableRangeSelection={true}
              getContextMenuItems={getContextMenuItems}
              getMainMenuItems={getMainMenuItems}
            />
          </div>
        </div>
      </div>

      {/* Overlay when slider is open */}
      {isSliderOpen && (
        <div
          className="overly-block"
          style={{ zIndex: 999 }}
          onClick={onClickingSliderCloseIcon}
        ></div>
      )}

      {/* Slider for Trigger */}
      <div
        className={`stock-status-slider ${isSliderOpen ? "open" : ""}`}
        style={{ width: "400px", maxWidth: "100%" }}
      >
        <div className="slider-header-container d-flex justify-content-between">
          <p className="m-0p">{sliderTitle}</p>
          <p
            className="m-0p"
            style={{ cursor: "pointer" }}
            onClick={onClickingSliderCloseIcon}
          >
            X&nbsp;&nbsp;&nbsp;
          </p>
        </div>

        <form style={{ padding: "20px" }} onSubmit={(e) => {
          e.preventDefault();
          setSliderOpen(false);
          onTriggerSubmit()
        }}>
          <div className="form-group mb-3">
            <label
              htmlFor="trigger-date"
              style={{
                fontSize: "0.9rem",
                fontWeight: "bold",
                color: "#333",
                marginBottom: "5px",
                display: "block",
              }}
            >
              Date <span style={{ color: "red" }}>*</span>
            </label>
            <Select
              inputId="trigger-date"
              value={triggerDateOption.find((d) => d.value === currentDate) || null}
              options={triggerDateOption}
              // options={allowedTriggerDates}
              // value={
              //   allowedTriggerDates.find((d) => d.value === triggerDate) || null
              // }
              // onChange={(selectedOption) => {
              //   setTriggerDate(selectedOption?.value || "");
              //   setDateError("");
              //   setDateStatus(
              //     selectedOption?.trigger_status === 0
              //       ? 0
              //       : selectedOption?.trigger_status === 1
              //       ? 1
              //       : ""
              //   );
              // }}
              styles={customStyles}
              placeholder="Select Date"
              isClearable
              required
            />
            {dateError && (
              <div
                style={{ color: "red", fontSize: "0.85rem", marginTop: "4px" }}
              >
                {dateError}
              </div>
            )}

            {triggerNote && (
              <div
                style={{
                  border: "1px solid",
                  borderColor:
                    triggerNote.status === "success"
                      ? "green"
                      : triggerNote.status === "warning"
                        ? "orange"
                        : "red",
                  backgroundColor:
                    triggerNote.status === "success"
                      ? "#e6ffed"
                      : triggerNote.status === "warning"
                        ? "#fff4e5"
                        : "#ffe6e6",
                  color:
                    triggerNote.status === "success"
                      ? "green"
                      : triggerNote.status === "warning"
                        ? "orange"
                        : "red",
                  padding: "12px",
                  borderRadius: "8px",
                  marginTop: "12px",
                  fontSize: "14px",
                  lineHeight: "20px",
                }}
              >
                <p style={{ margin: 0, fontWeight: "bold" }}>
                  Status: {triggerStatus === "warning" ? "Data Missing WARNING" : triggerNote.status.toUpperCase()}
                </p>
                {triggerStatus === "warning" ? null : <p style={{ margin: "6px 0" }}>{triggerNote.message}</p>}

                {triggerNote.missedWarehouses?.length > 0 && (
                  <p style={{ margin: "6px 0" }}>
                    <b>Missed Warehouses:</b> {triggerNote.missedWarehouses.join(", ")}
                  </p>
                )}

                {triggerNote.missedDarkstores?.length > 0 && (
                  <p style={{ margin: "6px 0" }}>
                    <b>Missed Darkstores:</b> {triggerNote.missedDarkstores.join(", ")}
                  </p>
                )}

                {triggerNote.stnStatus && (
                  <p style={{ margin: "6px 0" }}>
                    <b>STN Status:</b> {triggerNote.stnStatus}
                  </p>
                )}
              </div>
            )}
          </div>
          {/* <button
            type="button"
            className={`trigger-button ${
              dateStatus === 1
                ? "trigger-button-active"
                : "trigger-button-disabled"
            }`}
            disabled={dateStatus === 0}
            onClick={onReTriggerSubmit}
          >
            Re Trigger Inventory
          </button> */}
          {triggerStatus === "success" && primaryTriggerStatus === 1}

          <button
            type="submit"
            className={`trigger-button ${primaryTriggerStatus !== 1 && triggerStatus === "success"
                ? "trigger-button-active"
                : "trigger-button-disabled"
              }`}
            disabled={!(primaryTriggerStatus !== 1 && triggerStatus === "success")}
          >
            Trigger Inventory
          </button>
          {(primaryTriggerStatus === 1) && (
            <button
              type="button"
              // onClick={handleDownload}
              onClick={handleRevokeTrigger}
              style={{border : "none"}}
              
              className={"ml-4 px-4 py-2 text-white rounded trigger-button-active"}
            >
              Revoke Trigger
            </button>
          )}
        </form>

      </div>



      <div style={{ zIndex: 99999 }} className={`loader ${loadshow}`} ></div>
      <div style={{ zIndex: 997 }} className={`overlay-block ${overlayBlock}`}></div>
    </div>
  );
};

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    padding: "2px 6px",
    minHeight: "38px",
    borderRadius: "5px",
    borderColor: state.isFocused ? "#666" : "#ccc",
    fontSize: "0.9rem",
    boxShadow: "none",
    "&:hover": {
      borderColor: "#888",
    },
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999, // ensure it's above modals if needed
  }),
  option: (provided, state) => {
    const isTrigger = state.data.trigger_status === 1;
    const baseColor = "#93385D";
    const hoverColor = "#e6bccbff";

    return {
      ...provided,
      fontSize: "0.9rem",
      color: state.isSelected ? "white" : "#333",
      backgroundColor: state.isSelected
        ? baseColor
        : state.isFocused
          ? hoverColor
          : isTrigger
            ? "#f7f3d2" // light yellow for trigger
            : "white",
      "&:hover": {
        backgroundColor: state.isSelected ? baseColor : hoverColor,
        color: "white",
      },
      "&:active": {
        backgroundColor: baseColor,
        color: "white",
      },
    };
  },

  singleValue: (provided) => ({
    ...provided,
    fontSize: "0.9rem",
    color: "#333",
  }),
  placeholder: (provided) => ({
    ...provided,
    fontSize: "0.9rem",
    color: "#888",
  }),
};

const selectStyles = {
  control: (base) => ({
    ...base,
    padding: "1px",
    borderRadius: "5px",
    border: "1px solid #d9d9d9",
  }),
  singleValue: (base) => ({
    ...base,
    fontWeight: "normal",
    color: "#333",
    fontSize: "12px",
  }),
  option: (base, state) => ({
    ...base,
    fontSize: "13px",
    fontWeight: "normal",
  }),
};

export default NewFinishedGoodsInventory;
